'use strict';

var AnnotationTool = require('../annotation_tool');

var StrongTool = AnnotationTool.extend({
  name: "strong"
});

module.exports = StrongTool;



/*****************
 ** WEBPACK FOOTER
 ** ./~/substance/surface/tools/strong_tool.js
 ** module id = 245
 ** module chunks = 0
 **/